
/**
 * General popup function. Popup will be centered in viewport.
 * @param url
 * @param name
 * @param width
 * @param height
 */
function popup(url, width, height, name) {
	var vWidth = $(window).width();
	var vHeight = $(window).height();

	if (typeof(width)  == 'undefined') width  = 800;
	if (typeof(height) == 'undefined') height = 600;
	if (typeof(name)   == 'undefined') name   = 'popup';

	var top  = (vHeight / 2) - (height / 2);
	var left = (vWidth / 2)  - (width / 2);

	window.open(url, name, 'width=' + width + ',height=' + height + ',top=' + top + ',left=' + left + ',scrollbars=1,');
}


function openIframePopup(src) {
	var $modal  = $('.popup-modal');
	var $iframe = $modal.find('iframe');

	src += src.indexOf('?') >= 0 ? '&' : '?';
	src += 'popup=1';

	$iframe.off('load').on('load', function() {
		var element = this;
		var count = 0;
        var targetHeight = 0;
		var interval = setInterval(function() {
			count++;

			if (count >= 4) {
				// een aantal keer de hoogte checken, om rekening te houden met vertraagd geladen content
				clearInterval(interval);
				return;
			}

			var height      = element.contentWindow.document.body.scrollHeight + 20;
			var maxHeight   = $(window).height() - 80;
			var hasOverflow = false;

			if (height > maxHeight) {
				height = maxHeight;
				hasOverflow = true;
			}

            if (height === targetHeight) {
                return;
            }

            targetHeight = height;

			$iframe.stop(true).animate({
				'height': height + 'px'
			}, 300, function() {
				$modal.removeClass('loading').toggleClass('has-overflow', hasOverflow);
				$iframe.removeClass('invisible');
				$iframe.contents().find('body').css({
					'height': '100%',
					'overflow': 'auto',
					'-webkit-overflow-scrolling': 'touch'
				});
			});
		}, 200);
	});

	$modal.modal('show');
	$modal.addClass('loading');
	$iframe.addClass('invisible').css({
		'height': '150px'
	}).attr('src', src);
}


function showAlert(alert, okText) {
	var $popin = $('.alert-popin');
	var $btn   = $popin.find('.btn');

	if ($popin.is(':visible')) {
		return;
	}

	if (okText === undefined) {
		okText = $btn.data('text');
	}

	$btn.text(okText);
	$popin.find('.text').html(alert);
	$popin.modal({
		backdrop: 'static',
		keyboard: false
	});
}


function slideDownAlternative($elements, speed) {
	console.log($elements);

	$elements.each(function() {
		var currentHeight = $(this).innerHeight();
		var autoHeight    = $(this).css('height', 'auto').innerHeight();

		console.log(currentHeight, autoHeight);

		$(this).css('height', currentHeight).animate({
            height: autoHeight
        }, speed);
	});
}


function showConfirm(settings) {
	var $popin = $('.confirm-popin');

	settings = $.extend({
		text:           '',
		textYes:        $popin.find('.yes').data('text-yes'),
		textNo:         $popin.find('.yes').data('text-no'),
		urlYes:         '#',
		onConfirm:      null,
		closeOnConfirm: true,
	}, settings);

	if ($popin.is(':visible')) {
		return;
	}

	$popin.find('.text').html(settings.text);
	$popin.find('.yes').off('click').attr('href', settings.urlYes).text(settings.textYes);
	$popin.find('.no').text(settings.textNo);
	$popin.modal('show');

	$popin.find('.yes').on('click', (e) => {
		$popin.modal('hide');

		if (settings.onConfirm) {
			settings.onConfirm(e, $popin, settings);
		}
	});
}

function updateFileInputs() {
	$('.txtinput[type=file], .form-control[type=file]').each(function() {
		if ($(this).closest('.file-input').length > 0) {
			return;
		}

		$(this).wrap('<div class="file-input" />');

		var $parent = $(this).parent();

		$parent.append('<button type="button" class="btn"><i class="fa fa-file"></i> Choose file</button>');
		$parent.append('<input type="text" class="filename form-control" readonly>');

		$(this).on('change', function() {
			var file = $(this).get(0).files[0];
			$parent.find('.filename').val(file ? file.name : '');
		});
	});
}


function checkSidebarHeight() {
	var windowHeight  = $(window).height();
	windowHeight -= $('.navbar').outerHeight();
	windowHeight -= $('footer').outerHeight();

	// $('.sidebar').each(function() {
	// 	var sidebarHeight = $(this).outerHeight(true);
	//
	// 	if (sidebarHeight > windowHeight) {
	// 		$(this).addClass('no-affix');
	// 	} else {
	// 		$(this).removeClass('no-affix');
	// 	}
	// });

	// $('.menu-left').css('height', windowHeight);
}


function htmlEncode(string) {
	string = $('<div>').text(string).html();
	string = string.replace('"', '&quot;');
	return string;
}


function printOnly($element) {
    $('body').addClass('print-nothing');
    $element.addClass('print');
	$element.parents().addClass('print-parent');
    window.print();
    $element.removeClass('print');
	$element.parents().removeClass('print-parent');
    $('body').removeClass('print-nothing');
}


function isScrolledIntoView($element) {
    if ($element.length == 0 || !$element.is(':visible')) {
    	return false;
	}

    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();

    var elemTop = $element.offset().top;
    var elemBottom = elemTop + $element.height();

    return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
}


function openBackdrop(className, clickCallback) {
	if (typeof className == 'undefined') {
		className = 'backdrop';
	}

	var $backdrop = $('#main .' + className);

	if ($backdrop.length === 0) {
		$backdrop = $('<div class="' + className + '"></div>');
		$('#main').append($backdrop);
	}

	// if (!$backdrop.is(':visible')) {
		$backdrop.stop(true).fadeIn();
	// }

	if (typeof clickCallback == 'function') {
		$backdrop.on('click', clickCallback);
	}
}


function closeBackdrop(className) {
	if (typeof className == 'undefined') {
		className = 'backdrop';
	}

	var $backdrop = $('#main .' + className);

	if ($backdrop.length > 0) {
		$backdrop.stop(true).fadeOut();
		$backdrop.on('click', function() {});
	}
}


function getScrollbarWidth($element) {
    var remove = false;

    if (typeof($element) === 'undefined') {
        remove = true;
        $element = $('<div style="height:1px;overflow-y:scroll;"/>');
        $element.appendTo('body');
    }

    var scrollbarWidth = $element[0].offsetWidth - $element[0].clientWidth;
    if (remove) $element.remove();
    return scrollbarWidth;
}


function disableBodyScroll() {
	// https://css-tricks.com/prevent-page-scrolling-when-a-modal-is-open/
	$('body').addClass('scroll-disabled').css({
		// 'padding-right': getScrollbarWidth() + 'px',
		// 'position': 'fixed',
		// 'top': (-window.scrollY) + 'px'
	});
	// $('.navbar-fixed-top, .modal').css('margin-right', getScrollbarWidth() + 'px');
}


function enableBodyScroll() {
	const scrollY = document.body.style.top;

	$('body').css({
		// 'padding-right': '',
		// 'position': '',
		// 'top': ''
	}).removeClass('scroll-disabled').data('padding-right', '');
	// $('.navbar-fixed-top, .modal').css('margin-right', '');
	//
	// window.scrollTo(0, parseInt(scrollY || '0') * -1);
}


function smoothScrollTo($element, offset, duration) {
    if ($element.length === 0) return;

    if (duration === undefined) {
        duration = 1000;
    }

    $([document.documentElement, document.body]).stop(false, false).animate({
        scrollTop: $element.offset().top + (offset === undefined ? 0 : parseInt(offset))
    }, duration);
}


function smoothScrollToCenter($element, offset, duration) {
	if ($element.length === 0) return;

    offset -= $(window).height() / 2;
    smoothScrollTo($element, offset, duration);
}


function getElementsInViewport(selector) {
	var elements = [];

	$(selector).each(function() {
		var rect = this.getBoundingClientRect();

		if (
			rect.bottom >= 0 &&
			rect.right >= 0 &&
			rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
			rect.left <= (window.innerWidth || document.documentElement.clientWidth)
		) {
			elements.push($(this));
		}
	});

	return elements;
}

